/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'inferno-redux';
// actions used to manipulate application state
import { setTotalFrameCount } from 'redux/actions/content_status';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import OutOfContentScreen from 'components/content/outofcontent/outofcontent';



/* ========== ~~~~~~~~~~ OUT OF CONTENT SCREEN: PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ contentStatus, settings, contentData, embedStatus, rewards }, { contentId }) => ({
    currentContentStatus: contentStatus[contentId],
    currentContentSettings: settings.contentSettings[contentId],
    embedStatus,
    embedSettings: settings.embedSettings,
    settings: settings,
	// below added for tracking
    currentContentDataLength: contentData[contentId].data.length,
    rewardsSettings: rewards.settings,
    frameData: !!contentId ? contentData[contentId].data[contentStatus[contentId].frame] : null,
});

// map actions
const mapDispatchToProps = dispatch => ({
    setTotalFrameCount: (contentId, totalFrameCount) => dispatch(setTotalFrameCount(contentId, totalFrameCount))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
// will be utilized from any component that wants to incorporate "Content" component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OutOfContentScreen);
